import { render } from "./RoomList.vue?vue&type=template&id=72d5fa54&scoped=true"
import script from "./RoomList.vue?vue&type=script&lang=js"
export * from "./RoomList.vue?vue&type=script&lang=js"

import "./RoomList.vue?vue&type=style&index=0&id=72d5fa54&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/alice/alice_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72d5fa54"]])

export default __exports__